/* eslint-disable no-underscore-dangle */

import relatedService from 'player/services/api/related';
import assetService from 'player/services/api/asset';
import utils from 'utils/utils';
import Stream from './stream';
import Asset from './asset';

const createResponse = ({ nextAsset, source }) => ({
    nextAsset: nextAsset ? new Asset(nextAsset) : null,
    source
});

const handlers = {
    /**
     * Check if given asset has next stream
     * Used for setting/disabling postrolls
     *
     * @param asset
     * @returns {boolean}
     */
    hasPlayNext(asset) {
        if (asset.get('streamType') === 'live') {
            return false;
        }

        if (asset.get('nextAsset').id) {
            return true;
        }

        return false;
    },

    /**
     * Fetch next asset by providing it's id
     *
     * @param vendor
     * @param assetId
     * @param source
     * @returns {Promise<{nextAsset, source}>}
     */
    async fetchNextById({ vendor, assetId }) {
        const nextAsset = await assetService.getById({
            vendor,
            assetId
        });

        return createResponse({
            source: 'byId',
            nextAsset
        });
    },

    async fetchNextFromRelatedEngine({ vendor, assetId }) {
        const assets = await relatedService.getRelatedAssets({
            vendor,
            assetId,
            limit: 1
        });

        return createResponse({
            nextAsset: utils.isArray(assets) && assets.length > 0 ? assets[0] : undefined,
            source: 'related'
        });
    },

    /**
     * Fetch next for given asset
     * Cascade  lookup from direct linkage (nextAsset.id) to retrieving from category
     * Rejected when nextAsset is not found
     *
     * @param asset
     * @returns {Promise}
     */
    async getNext(asset) {
        const vendor = asset.getVendor();
        const assetId = asset.get('id');

        return this.fetchNextFromRelatedEngine({
            vendor,
            assetId
        });
    },

    /**
     * Fetch next for given asset
     * Cascade  lookup from direct linkage (nextAsset.id) to retrieving from category
     * Rejected when nextAsset is not found
     *
     * @param asset
     * @returns {Promise}
     */
    async fetchNext(asset) {
        const { nextAsset, source } = await this.getNext(asset);

        if (!nextAsset) {
            return Promise.reject({
                reason: 'nextAssetNotFound',
                source
            });
        }

        const stream = new Stream(nextAsset.attributes);

        if (!stream.isActive()) {
            return Promise.reject({
                reason: 'nextAssetNotActive',
                source
            });
        }

        return {
            nextAsset,
            source
        };
    }
};

export default handlers;
